import { BetaFeatureOnly } from "@/components/beta-feature";
import { NewChip } from "@/components/common/new-chip";
import { Button } from "@/toggle-ui-kit/button";
import { FileUp, FolderInput } from "lucide-react";

interface PageHeaderProps {
  /** DSD 보고서 업로드 버튼 클릭 (업로드 모달 열기) */
  onUpload?: () => void;
  /** IXD로 불러오기 클릭 — 베타에서만 노출한다. */
  onIxdForward?: () => void;
}

// ============================================
// PageHeader
// 홈(보고서 관리) 상단: 제목 · 소개 문구 · DSD 업로드 버튼.
// 파일 선택/업로드 처리는 업로드 모달이 담당한다.
// ============================================

export const PageHeader = ({ onUpload, onIxdForward }: PageHeaderProps) => (
  <div className="flex items-center gap-6 w-full">
    <div className="flex flex-1 min-w-0 flex-col items-start gap-2">
      <div className="flex items-center gap-2">
        <h1 className="title-2-bold text-label-normal whitespace-nowrap">
          DSD 워크북 관리
        </h1>
        <NewChip color="indigo" size="large" />
      </div>
      <p className="body-1-normal-regular text-label-neutral">
        DSD 보고서 업로드부터 태깅 · 버전 관리까지 한 곳에서 관리하세요.
      </p>
    </div>

    {onIxdForward ? (
      <BetaFeatureOnly>
        <Button
          variant="outlined"
          size="base"
          leftIcon={<FolderInput className="w-4 h-4" />}
          onClick={onIxdForward}
        >
          IXD로 불러오기
        </Button>
      </BetaFeatureOnly>
    ) : null}
    <Button
      variant="solid"
      size="base"
      leftIcon={<FileUp className="w-4 h-4" />}
      onClick={onUpload}
    >
      DSD 보고서 업로드
    </Button>
  </div>
);
